import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/modificator/Home';
import ComponentNotFound from '@/components/common/ComponentNotFound';
import Login from '@/components/modificator/Login';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (localStorage.is_logged_in) {
          next();
        } else {
          next({ name: 'Login' });
        }
      },
    },
    { path: '*', name: 'ComponentNotFound', component: ComponentNotFound },
    {
      path: '/',
      alias: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (localStorage.is_logged_in) {
          next({ name: 'Home' });
        } else {
          next();
        }
      },
    },
  ],
});
